import { useContext } from "react"
import { StyleContext } from "./style-context"
import { stylesToJs } from "../utils/styles-to-js"
import { addStyles } from "../utils/add-styles"

export const useStyles = () => {
  const { styles } = useContext(StyleContext)

  const forElement = (name, defaults) => {
    const allStyles = addStyles(name, styles)
    return stylesToJs(name, allStyles, defaults)
  }

  return { forElement, all: styles }
}
